export default __webpack_public_path__ + "static/media/icomoon.c5e2eff4.ttf";